import React from 'react'
import { Grid as BaseGrid, Hidden as BaseHidden, styled } from '@mui/material'
import { Button as BaseButton } from '@chilecompra/react-kit/components'

export const DesktopNavigation = styled('div')`
  display: grid;
  grid-template-columns: auto auto;
  grid-column-gap: 30px;
  margin: 0;
  width: 100%;
`

export const Hidden = styled(BaseHidden)``

export const Image = styled('img')`
  width: 100%;

  ${props => props.theme.breakpoints.down('xs')} {
    display: block;
    margin-left: auto;
    margin-right: auto;
    max-width: 140px;
  }
`

export const ImageContainer = styled('div')`
  align-items: center;
  display: flex;
  flex-direction: column;
  margin: -95px 0 0 39px;
`

export const Instructions = styled('section')`
  color: ${props => props.theme.palette.brand.black1};
  font-family: ${props => props.theme.typography.fontFamily};
  font-feature-settings:
    'clig' off,
    'liga' off;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 21px;
  margin-top: 28px;

  ${props => props.theme.breakpoints.down('sm')} {
    margin-top: 14px;
    text-align: left;
  }
`

export const Label = styled('label')`
  color: ${props => props.theme.palette.brand.black1};
  font-size: 12px;
  font-weight: 300;
  line-height: 16px;
`

export const MobileButtons = styled(BaseButton)`
  flex-grow: 1;
  width: 100%;
`

export const MobileNavigation = styled('div')`
  align-items: stretch;
  display: flex;
  flex-direction: column;
  gap: 18px;
  justify-content: center;
  width: 100%;

  ${props => props.theme.breakpoints.down('sm')} {
    margin: 0 auto;
    width: 90%;
  }
  ${props => props.theme.breakpoints.between('md', 'lg')} {
    width: 60%;
  }
`

export const Root = styled('div')`
  margin: 0;
  padding: 0 0 130px;
  width: 100%;
`

export const Section = styled(({ margin, maxWidth, padding, ...props }) => <BaseGrid {...props} />)`
  &.MuiGrid-container {
    margin: ${props => props.margin || 'initial'};
    max-width: ${props => props.maxWidth || 'initial'};
    padding: ${props => props.padding || '0'};
    text-align: left;
  }

  &.MuiGrid-item {
    margin: ${props => props.margin || 'initial'};
  }
`

export const SectionInputContainer = styled(Section)`
  input {
    background: ${props => props.theme.palette.brand.white};
    display: flex;
    text-align: left;
  }

  label {
    color: ${props => props.theme.palette.brand.black2};
  }
`

export const SectionPincodeContainer = styled(Section)`
  input {
    background: ${props => props.theme.palette.brand.gray3};
    text-align: center;
    max-width: 74px;
    ${props =>
      props.disabled &&
      `
      opacity: 0.4;
      pointer-events: none;
      user-select: none;
    `}
    ${props => props.theme.breakpoints.down('sm')} {
      max-width: 80px;
    }
    ${props => props.theme.breakpoints.between('sm', 'lg')} {
      max-width: 94px;
    }
  }

  label {
    color: ${props => props.theme.palette.brand.black2};
    font-size: 12px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    letter-spacing: 1.12px;
    margin-bottom: 13px;
    text-transform: uppercase;
  }
`

export const TimerLabelContainer = styled('div')`
  label {
    color: ${props => props.theme.palette.custom.baliHai};
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    letter-spacing: 0;
    line-height: normal;
  }
`

export const Title = styled('h1')`
  color: ${props => props.theme.palette.brand.black1};
  font-family: ${props => props.theme.typography.fontFamily};
  font-feature-settings:
    'clig' off,
    'liga' off;
  font-size: 27px;
  font-style: normal;
  font-weight: 700;
  line-height: 31px;

  ${props => props.theme.breakpoints.down('sm')} {
    font-size: 22px;
    line-height: 26px;
    margin: 0;
    text-align: left;
  }
`

export const ToastContainer = styled('div')`
  align-items: center;
  display: flex;
  justify-content: center;

  div {
    align-items: center;
    display: flex;
    gap: 5px;
  }

  & span {
    font-feature-settings:
      'liga' off,
      'clig' off;
    font-family: ${props => props.theme.typography.fontFamily};
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 18px;
    color: ${props => props.theme.palette.brand.black1};
  }
`
